define( function() {

"use strict";

/**
 * Determines whether an object can have data
 */
return function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/data/var/acceptData.js
// module id = 1552
// module chunks = 37